export const TelegramIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.42495 11.3751L11.4083 8.38346M6.16662 5.2668L13.2416 2.90846C16.4166 1.85013 18.1416 3.58346 17.0916 6.75846L14.7333 13.8335C13.15 18.5918 10.55 18.5918 8.96662 13.8335L8.26662 11.7335L6.16662 11.0335C1.40829 9.45013 1.40829 6.85846 6.16662 5.2668Z"
      stroke="black"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
